/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgradeRuleRequestChainingRules
 */
export interface UpgradeRuleRequestChainingRules {
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequestChainingRules
     */
    loaderVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequestChainingRules
     */
    fwVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequestChainingRules
     */
    uiVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleRequestChainingRules
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpgradeRuleRequestChainingRules
     */
    orderIndex?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleRequestChainingRules
     */
    isDeleted?: boolean | null;
}

export function UpgradeRuleRequestChainingRulesFromJSON(json: any): UpgradeRuleRequestChainingRules {
    return UpgradeRuleRequestChainingRulesFromJSONTyped(json, false);
}

export function UpgradeRuleRequestChainingRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeRuleRequestChainingRules {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loaderVersion': !exists(json, 'loaderVersion') ? undefined : json['loaderVersion'],
        'fwVersion': !exists(json, 'fwVersion') ? undefined : json['fwVersion'],
        'uiVersion': !exists(json, 'uiVersion') ? undefined : json['uiVersion'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'orderIndex': !exists(json, 'orderIndex') ? undefined : json['orderIndex'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
    };
}

export function UpgradeRuleRequestChainingRulesToJSON(value?: UpgradeRuleRequestChainingRules | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loaderVersion': value.loaderVersion,
        'fwVersion': value.fwVersion,
        'uiVersion': value.uiVersion,
        'id': value.id,
        'orderIndex': value.orderIndex,
        'isDeleted': value.isDeleted,
    };
}

